{
  "actions": "Ενέργειες",
  "hideButtonLabel": "Εμφάνιση λιγότερων",
  "noTags": "Κανένα",
  "showAllButtonLabel": "Εμφάνιση όλων ({tagCount, number})"
}
